import React from "react";

import { TFunction } from "utils";

import { CurrencyCode } from "consts";

import { FarmPaymentsResponse } from "models";

import { PayoutImpactCard, Typography } from "components";

type PastPaymentsType = {
  farmPayments: FarmPaymentsResponse | undefined;
  t: TFunction;
  payoutYear: number;
  currency?: CurrencyCode;
};

export const PastPayments = ({ farmPayments, t, payoutYear, currency }: PastPaymentsType) => (
  <div className="row-margin-top">
    <Typography variant="h2" className="margin-bottom-200">
      {t("paymentsHeadline")}
    </Typography>
    {farmPayments?.referralPayments?.map((payment) => {
      // Only the referrals that have been paid (as they could be also "pending" but we decided to only show the paid)
      if (payment.status === "paid") {
        return (
          <PayoutImpactCard
            payout={payment.amount}
            currency={currency}
            invoiceDate={payment.date}
            deductedPayout={undefined}
            icons={[{ icon: "tabler/user" }]}
            variant={"referral"}
            className="margin-bottom-100"
            unsigned={true}
            key={`${payment.date}`}
            dataTestId="wallet-payout-impact-card-invoice-referral"
          />
        );
      }
      return null;
    })}

    {farmPayments?.payments?.map((payment) => {
      if (payment.status === "paid" && payment.year <= payoutYear) {
        // Invoices
        return (
          <PayoutImpactCard
            payout={payment.amount}
            deductedPayout={payment.deductedAmount}
            currency={currency}
            invoiceDate={payment.date ?? undefined}
            icons={[{ icon: "tabler/wallet" }]}
            variant={"invoice"}
            year={payment.year}
            className="margin-bottom-100"
            unsigned={true}
            key={`${payment.year}-${payment.paymentId}`}
            dataTestId="wallet-payout-impact-card-invoice"
          />
        );
      }
      return null;
    })}
  </div>
);
